export default "__VITE_ASSET__79a779f5__"